import React from "react";
import Media from "react-media-universal";
import PropTypes from "prop-types";
import { Breakpoint } from "core-web/utils/mediaqueries";
import { labels } from "./breakpoints";
import { getMaxBreakpointValue } from "./calculations";

const Below = ({ breakpoint, render }) => (
    <Breakpoint.Consumer>
        {({ breakpointIndex }) => (
            <Media
                query={{ maxWidth: getMaxBreakpointValue(breakpoint) }}
                defaultMatches={breakpointIndex < labels.indexOf(breakpoint)}
                render={render}
            />
        )}
    </Breakpoint.Consumer>
);

Below.propTypes = {
    breakpoint: PropTypes.oneOf(labels).isRequired,
    render: PropTypes.func.isRequired,
};

export default Below;
